import React, { useMemo } from 'react';
import { Empty, Tabs } from 'antd';
import { useTranslation } from 'react-i18next';

import WmsNoUpdateTable, { WmsNoUpdateScope } from '../no-update-shared/WmsNoUpdateTable';
import { useWarehouseContext } from '../../../contexts/WarehouseContext';

/**
 * Hub 由左侧 WMS 仓库选择器决定；顶部 tab 切换：仓内断更（3 种 type）/ 尾程断更（LAST_MILE）
 */
const WmsNoUpdateHubPage: React.FC = () => {
    const { t } = useTranslation();
    const { currentWarehouse } = useWarehouseContext();
    const effectiveHubId = currentWarehouse?.id != null ? Number(currentWarehouse.id) : undefined;

    // scope 引用必须稳定：子组件按 scope 做 useMemo / useQuery variables，每次重渲染新对象会让
    // 下拉地点接口被无谓重发，期间 data 短暂为 undefined → options 闪空 → Select 选中态 fallback 成 id 数字
    const scope: WmsNoUpdateScope | null = useMemo(
        () => (effectiveHubId == null ? null : { kind: 'hub', hubId: effectiveHubId }),
        [effectiveHubId],
    );

    if (scope == null) {
        return (
            <div className="bg-white rounded-lg shadow-sm px-3 pb-3 pt-3">
                <Empty description={t('wms.dashboard.noUpdate.empty.selectHub')} />
            </div>
        );
    }

    return (
        <div className="bg-white rounded-lg shadow-sm px-3 pb-3 pt-0">
            <Tabs
                defaultActiveKey="IN_HUB"
                destroyInactiveTabPane
                className="[&_.ant-tabs-tab]:font-bold"
                items={[
                    {
                        key: 'IN_HUB',
                        label: t('wms.dashboard.noUpdate.tab.inHub'),
                        children: <WmsNoUpdateTable scope={scope} category="IN_HUB" />,
                    },
                    {
                        key: 'LAST_MILE',
                        label: t('wms.dashboard.noUpdate.tab.lastMile'),
                        children: <WmsNoUpdateTable scope={scope} category="LAST_MILE" />,
                    },
                ]}
            />
        </div>
    );
};

export default WmsNoUpdateHubPage;
